<template>
  <v-flex xs12>
    <table class="csv-field-mapping">
      <thead>
        <tr>
          <th>CSV column</th>
          <th>Sample</th>
          <th>Maps to</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in mappings"
          :key="index"
          :class="{ 'csv-field-mapping__excluded': !row.fieldName }"
        >
          <td class="csv-field-mapping__header">{{ row.csvHeader }}</td>
          <td class="csv-field-mapping__sample">{{ formatSample(row.sample) }}</td>
          <td>
            <v-select
              :items="optionsFor(index)"
              :value="selectValue(row)"
              item-text="label"
              item-value="name"
              dense
              box
              hide-details
              class="mt-0 pt-0"
              @change="onChange(index, $event)"
            />
          </td>
          <td class="csv-field-mapping__actions">
            <v-btn
              v-if="row.fieldName"
              flat
              small
              color="secondary"
              class="text-none ma-0"
              @click="exclude(index)"
            >
              Exclude
            </v-btn>
            <v-btn
              v-else
              flat
              small
              color="secondary"
              class="text-none ma-0"
              @click="includeAgain(index)"
            >
              Include
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
  </v-flex>
</template>

<script>
import { fieldSelectOptions, SKIP_IMPORT } from "@/helpers/csvFieldMatch"

export default {
  name: "csv-field-mapping",
  props: {
    mappings: {
      type: Array,
      default: function () {
        return []
      },
    },
    templateFields: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  methods: {
    optionsFor(index) {
      return fieldSelectOptions(this.templateFields, this.mappings, index)
    },
    selectValue(row) {
      return row.fieldName ? row.fieldName : SKIP_IMPORT
    },
    formatSample(value) {
      if (value == null || value === "") return "—"
      const text = String(value)
      if (text.length > 60) return text.slice(0, 57) + "..."
      return text
    },
    onChange(index, value) {
      const fieldName = value === SKIP_IMPORT || value === "" ? null : value
      this.$emit("change-mapping", { index: index, fieldName: fieldName })
    },
    exclude(index) {
      this.$emit("change-mapping", { index: index, fieldName: null })
    },
    includeAgain(index) {
      const options = this.optionsFor(index)
      const firstField = options.find(function (opt) {
        return opt.name && opt.name !== SKIP_IMPORT
      })
      if (firstField) {
        this.$emit("change-mapping", { index: index, fieldName: firstField.name })
      }
    },
  },
}
</script>

<style scoped>
.csv-field-mapping {
  width: 100%;
  border-collapse: collapse;
}
.csv-field-mapping th,
.csv-field-mapping td {
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}
.csv-field-mapping th {
  background: #f5f5f5;
  font-weight: 600;
}
.csv-field-mapping__header {
  font-family: monospace;
  white-space: nowrap;
}
.csv-field-mapping__sample {
  max-width: 240px;
  color: #666;
  word-break: break-word;
}
.csv-field-mapping__excluded .csv-field-mapping__header,
.csv-field-mapping__excluded .csv-field-mapping__sample {
  opacity: 0.55;
  text-decoration: line-through;
}
.csv-field-mapping__actions {
  white-space: nowrap;
  width: 1%;
}
</style>
